// extracted by mini-css-extract-plugin
export default {"row":"formrow_row__eI7qv","tight":"formrow_tight__ZVF9L"};